import * as React from 'react';
import Title from './components/Title';

interface SectionProps {
  className?: string;
  style?: any;
  children?: React.ReactNode[] | React.ReactNode;
}

const Section = ({ className, style, children }: SectionProps) => {
  return (
    <div className={`br-section-wrapper pd-20${className ? ` ${className}` : ``}`} style={style}>
      {children}
    </div>
  );
};

Section.Title = Title;

export default Section;
